module.exports = __webpack_public_path__ + "resources/img/4@3x.ab5add91.png";